import React from 'react';
import {timeAgo} from "lib/format";

// default updateInterval is 1 min
const DEFAULT_UPDATE_INTERVAL = 60000;

/**
 * A date display component that updates on a set interval
 * uses lib/format/formatTimeAgo
 */
export default class LiveDate extends React.Component {
  constructor(props) {
    super(props);
    if(this.props.updateInterval === undefined) {
      this.updateInterval = DEFAULT_UPDATE_INTERVAL;
    }
  }
  componentDidMount() {
    // Create a "tick" method, that re-calculates the time
    // force an update every tick (because the delta has always changed)
    this.tick = setInterval( () => {
      this.forceUpdate();
    }, this.updateInterval)
  }
  // Remove the timer
  componentWillUnmount() {
    clearInterval(this.tick);
  }

  render() {
    return (
      <span className="live-date">{timeAgo(this.props.date, this.props.timezoneOffset)}</span>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/LiveDate.js